import {
  ADD_ARRAY_ORDERS,
  CREATE_ORDER,
  EDIT_ORDER,
  LIST_ORDERS,
  SET_LOADING,
  PLAY_NOTIFICATION,
  STOP_NOTIFICATION,
  NEW_MESSAGE,
  LOAD_MESSAGES,
  SET_MESSAGE_AS_SEEN,
  DELETE_ORDER,
  EDIT_ORDER_SKETCH,
  ORDERS_CONTINGENCY,
  ADD_ORDERS_CONTINGENCY,
  EDIT_ORDERS_CONTINGENCY,
  TABLES_LENGTH,
  CREATE_INUTILIZED_INVOICE,
  LIST_INUTILIZED_INVOICES,
  LIST_DEVOLUTION_ORDERS,
  DEVOLUTION_ORDERS_TABLE_LENGTH
} from './mutation-types';
import moment from 'moment';

export default {
  [EDIT_ORDER_SKETCH]: (state, { order }) => {
    const indice = state.orders.findIndex((t) => t.id === order.id);
    order.isSketch = true;
    if (indice > 0) {
      state.orders.splice(indice, 1, order);
    }
  },
  [EDIT_ORDER]: (state, { order }) => {
    const orders = state.orders.filter((t) => t.id === order.id && !t.data);
    if (orders.length) {
      const indice = state.orders.findIndex((t) => t.id === order.id);
      state.orders.splice(indice, 1, Object.assign(orders[0], order));
    }
  },
  [CREATE_ORDER]: (state, { order }) => {
    state.orders.push(order);
  },
  [DELETE_ORDER]: (state, { order }) => {
    const indice = state.orders.findIndex((t) => {
      if (order.isSketch)
        return t.id === order.sketchId && t.data !== undefined;
      else return t.id === order.id;
    });
    state.orders.splice(indice, 1);
  },
  [LIST_ORDERS]: (state, { orders }) => {
    state.orders = orders;
  },
  [TABLES_LENGTH]: (state, { orders }) => {
    state.ordersTableLength = orders;
  },
  [LOAD_MESSAGES]: (state, { messages }) => {
    state.ordersMessages = messages;
  },
  [PLAY_NOTIFICATION]: (state) => {
    const player = document.getElementById('player');
    player.play();
  },
  [STOP_NOTIFICATION]: (state) => {
    const player = document.getElementById('player');
    player.pause();
  },
  [ADD_ARRAY_ORDERS]: (state, { orders }) => {
    orders.forEach((order) => {
      if (state.orders.filter((o) => +o.id === +order.id).length == 0) {
        state.orders.push(order);
        // notify();
      }
    });
  },
  [NEW_MESSAGE]: (state, { message }) => {
    if (state.ordersMessages.filter((m) => +m.id === +message.id).length == 0) {
      state.ordersMessages.push(message);
    }
  },
  [SET_MESSAGE_AS_SEEN]: (state, { orderId, isCompany }) => {
    state.ordersMessages = state.ordersMessages.map((m) => {
      if (m.orderId != orderId) return m;
      if (isCompany && m.senderType == 0) return m;
      if (!isCompany && m.senderType == 1) return m;

      return {
        ...m,
        seenAt: moment().format('YYYY-MM-DD HH:mm:ss'),
      };
    });
  },
  [SET_LOADING]: (state, { loading }) => {
    state.loading = loading;
  },
  [ORDERS_CONTINGENCY]: (state, { contingenciesCount }) => {
    state.ordersContingency = contingenciesCount;
  },
  [ADD_ORDERS_CONTINGENCY]: (state, { order }) => {
    state.ordersContingency.push(order);
  },
  [EDIT_ORDERS_CONTINGENCY]: (state, { orders }) => {
    orders.map((order) => {
      const orders = state.orders.filter((o) => o.id === order.id);
      if (orders.length) {
        const indice = state.ordersContingency.findIndex(
          (o) => o.id === order.id
        );
        state.ordersContingency.splice(indice, 1);
        const indiceOrder = state.orders.findIndex((o) => o.id === order.id);
        state.orders.splice(indiceOrder, 1, order);
      }
    });
  },
  [LIST_INUTILIZED_INVOICES]: (state, { inutilizedInvoices }) => {
    state.inutilizedInvoices = inutilizedInvoices;
  },
  [CREATE_INUTILIZED_INVOICE]: (state, { inutilizedInvoice }) => {
    state.inutilizedInvoices.push(inutilizedInvoice);
  },
  [LIST_DEVOLUTION_ORDERS]: (state, { orders }) => {
    state.ordersForDevolution = orders;
  },
  [DEVOLUTION_ORDERS_TABLE_LENGTH]: (state, { orders }) => {
    state.ordersForDevolutionTableLength = orders;
  },
};
